export enum Language {
    English,
    Persian
}
